import { create } from 'zustand';

interface AppNavigationActions {
    setCurrentPathname: (pathname: string) => void;
    setPageLoadId: (pageLoadId: string | null) => void;
}

interface AppNavigationState {
    currentPathname: string;
    pageLoadId: string | null;
    actions: AppNavigationActions;
}

/**
 * Ambient navigation state read outside React (lib/metrics.ts, stores/tradingSync.ts)
 * as well as by components building analytics payloads. Not persisted — reset on reload.
 */
export const useAppNavigationStore = create<AppNavigationState>()((set) => ({
    currentPathname: '',
    pageLoadId: null,

    actions: {
        setCurrentPathname: (pathname) => set({ currentPathname: pathname }),
        setPageLoadId: (pageLoadId) => set({ pageLoadId }),
    },
}));
